var _defs, _rect, _rect2, _circle, _path, _text, _text2, _text3, _path2, _rect3, _circle2, _circle3, _path3, _text4, _text5, _text6, _path4, _rect4, _circle4, _rect5, _path5, _text7, _text8, _text9, _path6, _rect6, _circle5, _path7, _text0, _text1, _text10, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportComplianceProblemSitePositionEvidenceModelMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 620,
    height: 1080,
    viewBox: "0 0 620 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Work Passport mobile site position evidence readiness model") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wp-problem-mobile-panel",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF3FD"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "wp-problem-mobile-shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 12,
    stdDeviation: 16,
    floodColor: "#07152A",
    floodOpacity: 0.1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 584,
    height: 1044,
    rx: 36,
    fill: "url(#wp-problem-mobile-panel)",
    stroke: "#C9DDF1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 62,
    width: 508,
    height: 170,
    rx: 22,
    fill: "#FFFFFF",
    stroke: "#D2E1F2",
    filter: "url(#wp-problem-mobile-shadow)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 147,
    r: 37,
    fill: "#087CFF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109 160v-27h30v27M116 140h3m5 0h3m5 0h3M116 148h3m5 0h3m5 0h3M106 160h36",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 114,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 850,
    letterSpacing: 1.5
  }, "SITE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 154,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 830
  }, "North Processing Plant")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 190,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 650
  }, "Site-specific rules")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M310 232v44m-8-9 8 9 8-9",
    fill: "none",
    stroke: "#9CCCF2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 276,
    width: 508,
    height: 170,
    rx: 22,
    fill: "#FFFFFF",
    stroke: "#D2E1F2",
    filter: "url(#wp-problem-mobile-shadow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 361,
    r: 37,
    fill: "#FF2775",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 353,
    r: 7,
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111 375c1-9 6-13 13-13s12 4 13 13M117 366l7 6 7-6",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 328,
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 850,
    letterSpacing: 1.5
  }, "POSITION")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 368,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 830
  }, "Maintenance Technician")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 404,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 650
  }, "Role-specific duties")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M310 446v44m-8-9 8 9 8-9",
    fill: "none",
    stroke: "#9CCCF2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 490,
    width: 508,
    height: 170,
    rx: 22,
    fill: "#FFFFFF",
    stroke: "#D2E1F2",
    filter: "url(#wp-problem-mobile-shadow)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 575,
    r: 37,
    fill: "#30D6A1",
    fillOpacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 558,
    width: 28,
    height: 34,
    rx: 3,
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117 567h14M117 574h9M117 583l4 4 9-10",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 542,
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 850,
    letterSpacing: 1.5
  }, "EMPLOYEE EVIDENCE")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 582,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 830
  }, "9 of 11 requirements current")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 618,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 650
  }, "Dates, documents and validity")), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M310 704v40m-8-9 8 9 8-9",
    fill: "none",
    stroke: "#9CCCF2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 762,
    width: 508,
    height: 244,
    rx: 26,
    fill: "#07152A",
    filter: "url(#wp-problem-mobile-shadow)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 839,
    r: 39,
    fill: "#FF6B67",
    fillOpacity: 0.14
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130 818v31M130 864h.1",
    fill: "none",
    stroke: "#FF8E88",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 817,
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "LIVE READINESS RESULT")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 861,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 31,
    fontWeight: 860
  }, "Action required")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 902,
    fill: "#B9C8DC",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 650
  }, "2 requirements must be resolved")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 938,
    width: 286,
    height: 8,
    rx: 4,
    fill: "#203854"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 938,
    width: 222,
    height: 8,
    rx: 4,
    fill: "#F5B642"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportComplianceProblemSitePositionEvidenceModelMobile);
export default __webpack_public_path__ + "static/media/work-passport-compliance-problem-site-position-evidence-model-mobile.d9d5e177f5a0b72a8ed03400980697ef.svg";
export { ForwardRef as ReactComponent };